import React from 'react'

import Button from 'components/Button'
import Icon from 'components/Icon'
import NextImage from 'components/NextImage'
import Tag from 'components/Tag'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'

import classes from './Learn.module.scss'

/** @type {import('./types').default} */
const Learn = ({ item }) => {
  const { addEvent } = useEventContext({
    engagementComponent: 'category_hub',
  })
  return (
    <>
      <div className={classes.container}>
        <Tag color="purple">
          <Icon icon={['ic', 'interactive', 'article']} className={classes.icon} />
          {item.category.toLocaleLowerCase()}
        </Tag>
        <Typography variant="heading-lg" className={classes.title}>
          {item.title}
        </Typography>
        <Typography className={classes.description}>{item.description}</Typography>
        <Button
          variant="outlined"
          href={item.ctaUrl}
          className={classes.cta}
          {...addEvent({
            engagementDestination: 'go-to_article',
            engagementDetails: 'contentful_article',
            name: 'engagement_navigation',
          })}
        >
          {item.ctaText}
        </Button>
      </div>
      <div className={classes.imageContainer}>
        <NextImage src={item.image.url} alt="hub-learn" className={classes.image} layout="fill" />
      </div>
    </>
  )
}

export default Learn
